import { render, staticRenderFns } from "./DocumentsFilters.vue?vue&type=template&id=98789ae4&scoped=true"
import script from "./DocumentsFilters.vue?vue&type=script&lang=ts"
export * from "./DocumentsFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98789ae4",
  null
  
)

export default component.exports